import { HttpClient } from '../HttpClient';
/**
 * * Generate Report
 */

export const PostReport = async ({ DateFrom, DateTo, ReportType, OtherData = {} }) => {
  try {
    const { data } = await HttpClient.post(`api/reports/types/${ReportType}`, {
      DateFrom,
      DateTo,
      ...OtherData,
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
